module.exports = __webpack_public_path__ + "img/EDIT.6d31b0d1.svg";